import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { ERROR_RETRY } from '../lib/Error';
import { BABYFACE_URL } from '../lib/routes/Routes';
import Loading from '../components/common/organism/Loading';

/**
 * GET 방식에서만 사용 가능
 * @param {Component} 뷰
 * @param {string} API
 */
const WithLoading = ({ component: Component, url, padding, onlyLoader }) => {
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
    // setTimeout(fetchData, 1000); // 로딩 동작 확인. 위엣것 주석 처리 후
  }, [url]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BABYFACE_URL.concat(url));
      setData(response.data);
    } catch (e) {
      alert(ERROR_RETRY);
    }
    setLoading(false);
  };

  if (loading) return <Loading padding={padding} onlyLoader={onlyLoader} />;

  return <Component data={data} />;
};

export default WithLoading;
